// extracted by mini-css-extract-plugin
export default {"container":"localization-key_container__lKj0H","key":"localization-key_key__+Ax5p"};